<template>
  <div class="step-four">
    <div class="main">
      <div class="icon icon-logo2"></div>
      <p class="sub-title">芒果TV全新声音治愈类真人秀</p>
      <p class="main-title">《朋友请听好》第二季故事招募</p>
      <div class="pannel">
        <div class="pannel-content">
          <p>参与成功！</p>
          <p>请耐心等待，每个账号只能参与一次</p>
        </div>
      </div>
      <div class="btn-normal" @click="onClickBtn">邀请朋友一起加入</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClickBtn() {
      this.$emit("share");
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/mixins.scss";

.step-four {
  .btn-normal {
    @include px2vw(font-size, 32);
    padding: 0.75em 4em;
  }
  .btn {
    position: relative;
    background-image: url("~@/assets/img/btn-2.png");
    @include px2vw(width, 305);
    @include px2vw(height, 85);
    @include px2vw(line-height, 85);
    @include px2vw(font-size, 35);
    font-weight: bold;
    margin: 0 auto;
  }
  .btn-wrapper {
    position: relative;
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 85);
  }
  .main {
    @include px2vw(padding-top, 60);
    @include px2vw(width, 690);
    margin: 0 auto;
    color: #333333;
    text-align: center;
    @include px2vw(font-size, 24);
    @include px2vw(line-height, 33);
  }

  .main-title {
    font-weight: 500;
    @include px2vw(line-height, 50);
    @include px2vw(font-size, 36);
  }
  .sub-title {
    font-weight: 500;
    @include px2vw(line-height, 40);
    @include px2vw(font-size, 28);
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 20);
  }

  .icon {
    &-logo2 {
      margin: 0 auto;
    }
    &-cat {
      @include px2vw(bottom, 0);
      @include px2vw(right, 0);
      transform: translateY(100%);
    }
    &-line3 {
      @include px2vw(bottom, 0);
      @include px2vw(right, 0);
      transform: translate(50%, 55%);
    }
  }

  .line-wrapper {
    position: relative;
  }
  .pannel {
    &-wrapper {
      @include px2vw(padding-top, 195);
      @include px2vw(line-height, 40);
    }
    &-content {
      font-weight: 500;
      text-align: center;
      @include px2vw(line-height, 42);
      @include px2vw(font-size, 30);
      p:first-child {
        @include px2vw(font-size, 34);
        @include px2vw(margin-bottom, 24);
      }
    }
    position: relative;
    background-image: url("~@/assets/img/panel-3.png");
    @include px2vw(width, 610);
    @include px2vw(height, 315);
    @include px2vw(padding-top, 90);
    margin: 0 auto;
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 40);
  }
}
</style>
